import {ApiRequestor} from "@/classes/requestors/api.requestor";

export class DtoApiDeletePersonRequest extends ApiRequestor {
  async $deletePerson(personId, organizationId) {
    const payload = {personId: personId, organizationId: organizationId};
    return this.$http('DELETE', `persons`, {payload});
  }
}
